module.exports = __webpack_public_path__ + "img/security_150.2ec8e046.webp";